import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import useElectronHook from "@/shared/hooks/useElectronHook";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";

const useOpenCustomerScreenAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const { isElectron } = useElectronHook();

  return {
    name: "openCustomerScreen" as CurrentActionTypes,
    label: t("posOrders.openCustomerScreen"),
    set: () => window?.electronAPI?.openCustomerWindow(),
    instantSet: true,
    filtered: isElectron === false,
    disabled: false,
    iconVariant: "desktop",
  };
};

const OpenCustomerScreenAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = useOpenCustomerScreenAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default OpenCustomerScreenAction;
